class DeclarationFormSection {
    constructor(id, sectionTitleEN, sectionTitleBM, questions) {
      this.id = id;
      this.sectionTitleEN = sectionTitleEN;
      this.sectionTitleBM = sectionTitleBM;
      this.questions = questions;
    }
  }
  
export default DeclarationFormSection